export function isFalse(variable) {
    return variable === false;
}

export function isNotFalse(variable) {
    return variable !== false;
}
